import { NotificationPriority } from "./notifications_types";

export enum UserNotificationStatus {
  UNREAD = "unread",
  READ = "read",
  DELETED = "deleted",
}

export interface UserNotification {
  id: number;
  user_id: number;
  notification_id: number;
  status: UserNotificationStatus;
  custom_data: Record<string, any> | null;
  expiry_date?: Date;
  created_at: Date;
  updated_at: Date;
}

export interface UserNotificationWithDetails extends UserNotification {
  title: string;
  description: string;
  type: string;
  priority: NotificationPriority;
  action_url?: string;
  icon?: string;
}

